// These need to be imported first for IE to work
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//
import '@cmsgov/ds-medicare-gov/dist/css/index.css';
import $ from 'jquery';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import SessionTimeout from './SessionTimeout';

(async () => {
    const clientSideID = process.env.REACT_APP_LD_CLIENT_ID;
    const LDProvider = await asyncWithLDProvider({
        clientSideID,
        options: {
            baseUrl: 'https://app.launchdarkly.cms.gov',
            eventsUrl: 'https://events.launchdarkly.cms.gov',
            streamUrl: 'https://stream.launchdarkly.cms.gov',
            streaming: false,
        }
    });
   
    // tealium needs access to jQuery
    window.jQuery = $;
    window.$ = $;

    ReactDOM.render(
        <LDProvider>
            <BrowserRouter basename="/account">
                <App/>
                <SessionTimeout />
            </BrowserRouter>
        </LDProvider>,
        document.getElementById('app-root')
    );
})();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
